// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"afda299d","387":"273e7fc2","719":"83051382"}[chunkId] + ".chunk.css";
};